jQuery(window).scroll(function(){
  var sticky = jQuery('.header-container'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 30) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

$(document).ready(function(e) 
{
  
    $(document).on('click','a[href="#cartItemRemove"]',function(e){
    e.preventDefault();
	$(this).parents('.ajaxcart__row').find('.ajaxcart__qty-num').val(0).trigger('change');
    });
  
	$("a.open-bio").click(function() 
	{
		$(this).nextAll('.bio-more').first().toggle();
		$(this).toggleClass('active');
		return false;
	});
  
  let arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Left" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(-26.473 -16.028)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  let arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="26.578" height="51.156" viewBox="0 0 26.578 51.156"><path id="Right" d="M51.637,65.77,27.473,41.606,51.637,17.442" transform="translate(53.052 67.184) rotate(180)" fill="none" stroke="#030504" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>';
  
    $('.carousel-product').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev">'+arrowLeft+'</button>',
    nextArrow: '<button type="button" class="slick-next">'+arrowRight+'</button>',
    //prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    //nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [
         {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2, 
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1, 
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1, 
            }
          }
        ]
  });
  
});

$(document).ready(function() {	
  $('.et-tablink').click(function() {	
    var tab = $(this).data('tab');	
    $('.et-tabs-header .et-tablink').removeClass('active');	
    $('.et-tabs-content .et-tab-content').removeClass('active');	
    $(this).addClass('active');	
    $(".et-tabs-content #" + tab).addClass('active');	
  });
  $('.acc_list .acc_title').click(function() {
    var current_status = $(this).parent().find(".acc_desc").css('display');
    $('.acc_title').removeClass('active');
    $('.acc_list .acc_desc').slideUp();
    if(current_status == 'none') {
      $(this).addClass('active');
      $(this).parent().find(".acc_desc").slideDown();
    }
  });
  
    var mobileSearchIcon = setInterval(function() {
    if($('a[href="#mobiSearch"] form[action="/pages/search-results-page"]').length) {
      $('a[href="#mobiSearch"]').removeClass('disabled');
      clearInterval(mobileSearchIcon);
    }
  }, 100);
  
   var annoucment_slide = $('.announcement-bar').slick({
     infinite: true,
     slideToShow:1,
     autoplay: true,
     autoplaySpeed: 2000,
     arrows:false,
     vertical: true
  });
  
  
}); 

  $('.collection_slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3.5,
  arrows:false,
      responsive: [
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 2.3
      }
    }
  ]
  });

  $('.collection_slider_five').slick({ 
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5.5,
  adaptiveHeight: true,
  arrows:false,
  responsive: [
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 2.3
      }
    }
  ]
  });

$(document).ready(function ()
{
    const cart = document.querySelector('#CartDrawer #CartContainer');
    if ( !cart ) return;
    const observer = new MutationObserver((mutations) => 
    {
        mutations.forEach((mutation) => 
        {
            mutation.addedNodes.forEach((node) =>
            {
                if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('promo-inner'))
                {
                    [500, 1000].forEach(delay => 
                    {
                        setTimeout(wcPromoBoxAboveTerms, delay);
                    });
                }
            });
        });
        
    });
    observer.observe(cart, { childList: true, subtree: true });

    function wcPromoBoxAboveTerms() 
    {
        const cart = document.querySelector('#CartDrawer #CartContainer');
        const promo = cart.querySelector('.promo_product_status');
        const footer = cart.querySelector('.ajaxcart__footer');
        $(footer).prepend(promo);
    }
});

$(document).ready(function () 
{
    if ($('body').hasClass('template-product')) 
    {
        function fixedSampleButtons() 
        {
            if (!$('body').hasClass('template-product') || document.querySelector('.tz-card'))
                return;


            const $chatWidget = $('.widget-visible');
            const $header = $('.header-container');
            const $sampleProduct = $('.step1.pdp_sample__b .pdp_sample__l');
            const $sampleProductInner = $('.step1.pdp_sample__b .product--option.swatch');
            if (!$sampleProduct.length || !$sampleProductInner.length) return;
            const sampleProductInnerHeight = $sampleProductInner.outerHeight();

            const viewTop = $(window).scrollTop();
            const headerHeight = $header.outerHeight();
            const sampleProductTop = $sampleProduct.offset().top;
            const sampleProductBottom = sampleProductTop + $sampleProduct.outerHeight() + 50;

            $sampleProduct.css('cssText', `height : ${sampleProductInnerHeight}px !important`);

            $chatWidget.removeAttr('id');

            if (viewTop + headerHeight > sampleProductBottom) 
            {
                $sampleProductInner.addClass('fixed-sample-product');
                $chatWidget.hide();
            }
            else 
            {
                $sampleProductInner.removeClass('fixed-sample-product');
                $chatWidget.show();
            }
        }


        function throttle(func, delay) 
        {
            let timer = null;
            return function () {
                if (!timer) {
                    timer = setTimeout(() => {
                        func.apply(this, arguments);
                        timer = null;
                    }, delay);
                }
            };
        }

        const throttledFixedSampleButtons = throttle(fixedSampleButtons, 200);

        throttledFixedSampleButtons();
        $(window).scroll(function () 
        {
            throttledFixedSampleButtons();
        });
    }
});